import { GigPiece } from "../../entities/gigPiece";

export const RouterConfig = {
  root: "/",
  journal: "/journal",
  insights: "/insights",
  icsSubscription: "/ics-subscription",
  calendar: "/calendar",
  profile: "/profile",
  qrCode: "/qr-code",
  services: "/services",
  projects: "/projects",
  gigPieces: "/pieces",
  seasons: "/seasons",
  venues: "/venues",
  contractors: "/organizations",
  settings: "/settings",
  emails: "/emails",
};
